import type { HighlightedSeriesId } from '../components/interactions-state-helpers/types.js';

const CANVAS_DEFAULT_OPACITY = '1';
const CANVAS_DIMMED_OPACITY = '0.2';

/**
 * This utility function returns opacity to apply to a canvas element based on highlighted series.
 * This is not intended for any other use than dimming canvas elements when a particular series is highlighted.
 * @param highlightedSeriesId - The IDs of highlighted series
 */
export const applyOpacityToCanvas = (
  highlightedSeriesId: HighlightedSeriesId,
): string => {
  return highlightedSeriesId ? CANVAS_DIMMED_OPACITY : CANVAS_DEFAULT_OPACITY;
};
